<template>
  <div>
    <div class="special-menu" v-if="specialMenu">
      <div class="container">
        <div class="flexbox">
          <div class="sp-menu-item">
            <a
              href="#"
              @click.prevent="removeSpecialMenu"
            >{{ $t("Обычная версия сайта") }}</a>
          </div>
          <div class="sp-menu-item">
            <div class="f-size">
              {{ $t("Размер шрифта") }}:
              <a v-for="(value, key) in sizes"
                 v-bind:key="key"
                 href="#!"
                 :aria-pressed="value ? 'true' : 'false'"
                 :aria-label="$t('Размер шрифта') + ' ' + key"
                 :class="['f-size-item size_'+key, { active: value }]"
                 @click.prevent="addBodyClassSize(key)"
              >A</a>
            </div>
          </div>
          <div class="sp-menu-item">
            <div class="color-scheme">
              {{ $t("Цветовая схема") }}:
              <a v-for="(value, key) in colors"
                 v-bind:key="key"
                 href="#!"
                 :aria-pressed="value ? 'true' : 'false'"
                 :aria-label="$t('Цветовая схема') + ' ' + key"
                 :class="['color-scheme-item color_'+key, { active: value }]"
                 @click.prevent="addBodyClassColor(key)"
              >A</a>
            </div>
          </div>
          <div class="sp-menu-item">
            <div class="image-state">
              <span>{{ $t("Изображение") }}</span>
              <v-switch
                v-model="imageState"
                :aria-label="$t('Изображение')"
                @change="imageStateMtd"
              ></v-switch>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="navbar-top">
      <div class="container">
        <div class="auth-profile">
          <router-link :to="$i18nRoute({ name: 'login' })" v-if="!isLoggedIn">
            {{ $t("Личный кабинет") }}
          </router-link>
        </div>
        <div class="vis-impaired" v-if="!specialMenu">
          <a href="#" @click.prevent="addSpecialMenu">{{ $t("Версия для слабовидящих") }}</a>
        </div>
        <ProfileDropdown v-if="isLoggedIn" />
        <Language/>
      </div>
    </div>
  </div>
</template>

<script>
  import Language from '@/components/header/Language'
  import ProfileDropdown from '@/components/header/ProfileDropdown'
  // объявляем переменную глобально
  let myBody = null

  export default {
    components: {
      Language,
      ProfileDropdown
    },
    data: () => ({
      specialMenu: false,
      sizes: {
        One: false,
        Two: false,
        Three: false
      },
      colors: {
        White: false,
        Black: false
      },
      imageState: true
    }),
    computed: {
      isLoggedIn() {
        return this.$store.getters.isLoggedIn
      }
    },
    mounted() {
      // присваиваем body к переменному myBody
      myBody = document.getElementsByTagName('body')[0]

      // проверяем если в localStorage уже выбранные настройки по размеру шрифта (версия для слабовидящих)
      if(localStorage.userSettingsSize) {
        myBody.classList.add(localStorage.userSettingsSize)
        if (localStorage.userSettingsSize === 'sizeOne') {
          this.sizes.One = true
        }
        if (localStorage.userSettingsSize === 'sizeTwo') {
          this.sizes.Two = true
        }
        if (localStorage.userSettingsSize === 'sizeThree') {
          this.sizes.Three = true
        }
      }
      // проверяем если в localStorage уже выбранные настройки по цвету шаблона (версия для слабовидящих)
      if(localStorage.userSettingsColor) {
        myBody.classList.add(localStorage.userSettingsColor)
        if (localStorage.userSettingsColor === 'colorWhite') {
          this.colors.White = true
        }
        if (localStorage.userSettingsColor === 'colorBlack') {
          this.colors.Black = true
        }
      }
      // проверяем в localStorage включена ли "версия для слабовидящих"
      if(localStorage.specialMenu) {
        this.specialMenu = localStorage.specialMenu
      }
      // проверяем в localStorage Включен||Выключен Изображение (версия для слабовидящих)
      if(localStorage.userSettingsImage) {
        if (localStorage.userSettingsImage === 'false') {
          this.imageState = false
          myBody.classList.add('imageNone')
        }
      }
    },
    methods: {
      // добавляем SpecialMenu
      addSpecialMenu () {
        this.specialMenu = true
        localStorage.setItem('specialMenu', this.specialMenu);
      },
      // добавляем в тег body выбранный класс для размера, при этом удаляем все классы для размеров, которые были добавлены
      addBodyClassSize(size) {
        this.sizes = {
          One: false,
          Two: false,
          Three: false,
        }
        Object.keys(this.sizes).forEach((key) => {
          myBody.classList.remove('size'+key)
        })
        this.sizes[size] = true
        myBody.classList.add('size'+size)
        localStorage.setItem('userSettingsSize', 'size'+size)
      },
      // добавляем в тег body выбранный класс для цвета, при этом удаляем все классы для цветов, которые были добавлены
      addBodyClassColor(color) {
        this.colors = {
          White: false,
          Black: false
        }
        Object.keys(this.colors).forEach((key) => {
          myBody.classList.remove('color'+key)
        })
        this.colors[color] = true
        myBody.classList.add('color'+color)
        localStorage.setItem('userSettingsColor', 'color'+color)
      },
      // добавляем в тег body класс (imageNone - для скрытия картинок)
      imageStateMtd() {
        if (!this.imageState) {
          myBody.classList.add('imageNone')
          localStorage.setItem('userSettingsImage', this.imageState)
        } else {
          myBody.classList.remove('imageNone')
          localStorage.removeItem('userSettingsImage')
        }
      },
      // очищаем все из тега body (приводим в изначальный вид)
      removeSpecialMenu() {
        this.specialMenu = false
        this.sizes = {
          One: false,
          Two: false,
          Three: false
        }
        Object.keys(this.sizes).forEach((key) => {
          myBody.classList.remove('size'+key)
        })
        this.colors = {
          White: false,
          Black: false
        }
        Object.keys(this.colors).forEach((key) => {
          myBody.classList.remove('color'+key)
        })
        this.imageState = true
        myBody.classList.remove('imageNone')
        // удаляем все настройки из localStorage
        localStorage.removeItem('specialMenu')
        localStorage.removeItem('userSettingsSize')
        localStorage.removeItem('userSettingsColor')
        localStorage.removeItem('userSettingsImage')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .logout {
    margin-left: 30px;
  }
</style>
